"use strict";

var _objectSpread = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var util_1 = require("../../util");
var FeatureRendererType_1 = __importDefault(require("./FeatureRendererType"));
var RpcRenderedSvgGroup_1 = __importDefault(require("./RpcRenderedSvgGroup"));
var CircularChordRendererType = /*#__PURE__*/function (_FeatureRendererType_) {
  _inherits(CircularChordRendererType, _FeatureRendererType_);
  function CircularChordRendererType() {
    var _this;
    _classCallCheck(this, CircularChordRendererType);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(CircularChordRendererType).apply(this, arguments));
    _this.supportsSVG = true;
    return _this;
  }
  _createClass(CircularChordRendererType, [{
    key: "deserializeResultsInClient",
    value: function deserializeResultsInClient(res, args) {
      var deserializedFeatures = new Map(res.features.map(function (f) {
        return util_1.SimpleFeature.fromJSON(f);
      }).map(function (f) {
        return [f.id(), f];
      }));
      // if we are rendering svg, we skip hydration
      if (args.exportSVG) {
        // only return the res if the renderer explicitly has
        // this.supportsSVG support to avoid garbage being rendered in SVG
        // document
        return _objectSpread({}, res, {
          features: deserializedFeatures,
          blockKey: 'circularChord',
          html: this.supportsSVG ? res.html : '<text y="12" fill="black">SVG export not supported for this track</text>'
        });
      }
      // hydrate res using ServerSideRenderedContent
      return _objectSpread({}, res, {
        features: deserializedFeatures,
        blockKey: 'circularChord',
        reactElement: react_1.default.createElement(RpcRenderedSvgGroup_1.default, _objectSpread({}, args, res, {
          features: deserializedFeatures,
          RenderingComponent: this.ReactComponent
        }))
      });
    }
  }]);
  return CircularChordRendererType;
}(FeatureRendererType_1.default);
exports.default = CircularChordRendererType;